import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { useIsMimicking } from '../../hooks/useIsMimicking';
import { useSiteManagerState } from './useSiteManagerState';
import { createSiteManagerHandlers } from './useSiteManagerHandlers';

export const useSiteManager = () => {
  const { siteId } = useParams<{ siteId: string }>();
  const navigate = useNavigate();
  const isMimicking = useIsMimicking();
  const { isAdmin } = useAuth();

  const state = useSiteManagerState();

  const handlers = createSiteManagerHandlers({
    siteId,
    navigate,
    state,
  });

  // Initial data load
  useEffect(() => {
    if (!siteId) {
      navigate('/dashboard');
      return;
    }

    handlers.loadSiteData();
    handlers.checkPageCreationLimit();
    handlers.loadBlogData();
    handlers.loadLayoutsData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [siteId, navigate]);

  return {
    // Params
    siteId,
    navigate,
    isMimicking,
    isAdmin,

    // State
    ...state,

    // Handlers
    ...handlers,
  };
};
